import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowDown, ArrowUp, Sizes } from "@/components/icon/IconList";
import { alpha, ButtonBase, useTheme } from "@mui/material";
import PassButtonContent from "./PassButtonContent";
const PassSelectButton = (param)=>{
    let { open , pass , ...props } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(ButtonBase, {
        disableRipple: true,
        sx: (theme)=>({
                py: 1.5,
                px: 2,
                width: "100%",
                border: "1px solid",
                borderColor: "grey.200",
                backgroundColor: open ? alpha(theme.palette.grey[300], 0.2) : "transparent",
                borderRadius: "6px",
                "&:hover": {
                    backgroundColor: alpha(theme.palette.grey[300], 0.2)
                }
            }),
        ...props,
        children: /*#__PURE__*/ _jsx(PassButtonContent, {
            passContent: pass,
            rightContent: open ? /*#__PURE__*/ _jsx(ArrowUp, {
                size: Sizes.small,
                color: theme.palette.grey[500]
            }) : /*#__PURE__*/ _jsx(ArrowDown, {
                size: Sizes.small,
                color: theme.palette.grey[500]
            })
        })
    });
};
export default PassSelectButton;
